import React from "react";
import { Button, Dropdown, Menu, Tooltip } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { useStockPoDetailModel } from "../purchaseDetailsModel";
import useNavModel from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { disableExportMsg } from "@/utils/exportFile";
import { DownOutlined } from "@ant-design/icons";

export const DataBox = () => {
    const { selectedRowKeys, setShiftShelfModal, setSectionShelfModal, exportStockOut, statistics, setRecordsVisible } = useStockPoDetailModel();
    const { addNav, findNav, switchNavState } = useNavModel(() => []);

    const onLook = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行操作", type: "warning" });
            return;
        }
        let stockOutputEditKey = "4-4-1";
        let isFindNav = findNav(stockOutputEditKey);
        if (!isFindNav) {
            addNav(stockOutputEditKey, { id: selectedRowKeys[0], mode: "look" });
        } else {
            switchNavState(stockOutputEditKey, { id: selectedRowKeys[0], mode: "look" });
        }
    }

    const desc: IDescription[] = [
        {
            label: "库存成本",
            value: statistics?.stockAmount ?? 0,
            color: DescriptionColorEnum.red
        },
        {
            label: "库存数量",
            value: statistics?.stockNum ?? 0,
            color: DescriptionColorEnum.red
        },
    ]

    const shelfMenu = () => {
        return (
            <Menu>
                <Menu.Item key="0">
                    <span onClick={() => setShiftShelfModal(true)}>全部转移</span>
                </Menu.Item>
                <Menu.Item key="1">
                    <span onClick={() => setSectionShelfModal(true)}>部分转移</span>
                </Menu.Item>
            </Menu>
        )
    }

    const action = <>
        <YhAuth resCode={ResourceAuthEnum.ST_PO_TRANS}>
            <Dropdown overlay={shelfMenu}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                >货位转移<DownOutlined /></Button>
            </Dropdown>
            {/* <Button
                className="mr-5"
                type="primary"
                shape="round"
                // disabled={true}
                onClick={() => setShiftShelfModal(true)}
            >转移货位</Button> */}
        </YhAuth>
        <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={() => exportStockOut()}
        >导出</Button>
        <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={() => setRecordsVisible(true)}
        >转移记录</Button>
    </>;

    return (
        // <YhBox title="采购明细列表" descriptions={desc} action={action} style={{height:'calc(100vh - 200px)'}}>
        <YhBox action={action} style={{ height: 'calc(100vh - 180px)' }}>
            <DataTable />
        </YhBox>
    )
}